// extracted by mini-css-extract-plugin
export var eventsSection = "events-module--eventsSection--DPTdw";
export var backgroundImage = "events-module--backgroundImage--3myFV";
export var events = "events-module--events--1EJyf";
export var event = "events-module--event--LzG1M";
export var title = "events-module--title--Wuyrp";
export var description = "events-module--description--oaLqO";
export var details = "events-module--details--2Bl78";